module.exports = __webpack_public_path__ + "img/userB13.9ccd2af7.jpg";